import { BookOpen, FileText, LogOut, MessageSquare, Settings } from 'lucide-react'

/** Gemeinsame Icons für die Einträge des Benutzermenüs (Größe 18 px, wie .ui-menu-ic). */
export const USER_MENU_ICON_CLASS = 'h-[18px] w-[18px]'

export const UserMenuIcons = {
  settings: <Settings className={USER_MENU_ICON_CLASS} />,
  feedback: <MessageSquare className={USER_MENU_ICON_CLASS} />,
  handbookShort: <FileText className={USER_MENU_ICON_CLASS} />,
  handbookLong: <BookOpen className={USER_MENU_ICON_CLASS} />,
  logout: <LogOut className={USER_MENU_ICON_CLASS} />,
}
